/**
 * Transformer les callbacks du plugin jQuery Validation
 * en trigger d'évènement.
 *
 * Chaque input ayant une validation va lever un 
 * évènement "validate". Le second argument de l'évènement
 * est un objet contenant (ou non) l'erreur.
 */


// Dependecies
var $ = require('jquery');


// Export the options object
module.exports = {

    // Error placement
    errorPlacement: function (error, element) {
        element.trigger("validate", {
            error: error.text()
        });
    },


    // Field highlight
    highlight: function (element, errorClass, validClass) {
        // Ne rien faire...
        // 'errorPlacement' est toujours exécuté après
        // cette fonction. Le rôle de cette fonction est
        // seulement pour ajouter une classe d'erreur.
    },


    // Field remove highlight
    unhighlight: function (element, errorClass, validClass) {
        $(element).trigger("validate", {
            error: null
        });
    }

};


// WEBPACK FOOTER //
// ./Sig.Web/src/utils/forms-validation/options/defaults.js